'use strict';

export default {
  paymentAccounts: {
    buttons: {
      edit: 'Modifier',
      delete: 'Supprimer',
      addAccount: 'Ajouter Compte',
      cancel: 'Annuler',
      save: 'Sauvegarder',
      stripePortal: 'Aller sur le compte Stripe',
    },
    labels: {
      accounts: 'Payment Accounts',
      deleteAccount: 'Êtes-vous sûr de vouloir supprimer ce compte de paiement ?',
      editModalTitle: 'Modifier compte de paiement',
      accountName: 'Nom du compte',
      editSuccess: 'Modification du compte de paiement réussie',
      deleteSuccess: 'Suppression du compte de paiement réussie',
      delete: 'Supprimer compte',
      editError: 'La modification du compte de paiement a échoué',
      deleteError: 'La suppression du compte de paiement a échoué',
      noAccounts: "Il n'y a pas de comptes de paiement pour cette organization",
    },
  },
};
